<div class="product-form-quote-dialog">
	<div #productFormQuote class="product-form-quote-container" *ngIf="!isSuccess">
		<section class="modal-header">
			<h3 *ngIf="formTitle">{{ formTitle }}</h3>
			<h3 *ngIf="!formTitle" i18n>Request quote</h3>
			<g-icon
				[icon]="icons.faXmark"
				class="close-dialog"
				(click)="closeDialog()"
				role="button"
				i18n-title
				title="Close"
			/>
		</section>
		<section class="modal-body">
			<p class="info" [innerHTML]="formDescription"></p>
			<form id="product-quote" [formGroup]="productFormQuoteForm" (ngSubmit)="onSubmit()">
				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="48" fxFlex.xs="100">
						<label for="product-form-quote-dialog-first-name" class="is-required" i18n>First name</label>
						<input
							type="text"
							trim="blur"
							id="product-form-quote-dialog-first-name"
							class="form-control form-control-primary"
							formControlName="firstName"
							autocomplete="given-name"
							data-cy="firstName"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'firstName' }}
						</div>
					</div>
					<div fxFlex="4" fxFlex.xs="0"></div>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="product-form-quote-dialog-last-name" class="is-required" i18n>Last name</label>
						<input
							type="text"
							trim="blur"
							id="product-form-quote-dialog-last-name"
							class="form-control form-control-primary"
							formControlName="lastName"
							autocomplete="family-name"
							data-cy="lastName"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'lastName' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary" fxLayout="row" fxLayout.xs="column">
					<div fxFlex="48" fxFlex.xs="100">
						<label for="product-form-quote-dialog-email" class="is-required" i18n>Email</label>
						<input
							type="email"
							id="product-form-quote-dialog-email"
							class="form-control form-control-primary"
							formControlName="email"
							autocomplete="work email"
							data-cy="email"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'email' }}
						</div>
					</div>
					<div fxFlex="4" fxFlex.xs="0"></div>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="product-form-quote-dialog-phone" class="is-required" i18n>Phone number</label>
						<input
							type="tel"
							id="product-form-quote-dialog-phone"
							class="form-control form-control-primary"
							formControlName="phone"
							autocomplete="work tel"
							data-cy="phone"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'phone' }}
						</div>
					</div>
				</div>

				<div
					class="form-group form-group-primary"
					fxLayout="row"
					fxLayout.xs="column"
					*ngIf="isCompanyVisible"
				>
					<div fxFlex="48" fxFlex.xs="100">
						<label for="product-form-quote-dialog-company" i18n>Company</label>
						<input
							type="text"
							trim="blur"
							id="product-form-quote-dialog-company"
							class="form-control form-control-primary"
							formControlName="company"
							autocomplete="organization"
							data-cy="company"
						/>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'company' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary" fxLayout="row">
					<div fxFlex="100">
						<label for="product-form-quote-dialog-message" class="is-required" i18n>Your message</label>
						<textarea
							id="product-form-quote-dialog-message"
							class="form-control form-control-primary"
							formControlName="message"
							rows="12"
							data-cy="message"
						></textarea>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'message' }}
						</div>
					</div>
				</div>

				<div class="form-group form-group-primary">
					<label i18n>Upload file</label>
					<!-- TODO: Use the FileType enum -->
					<g-upload fileType="ATTACHMENT" (onUploadComplete)="setAttachment($event)" />
				</div>

				<div class="button-container" fxLayout="row" fxLayoutAlign="center">
					<button
						type="submit"
						class="btn btn-primary"
						[disabled]="!productFormQuoteForm.valid || isProcessing"
						[ngClass]="{ 'is-submitting': isProcessing }"
					>
						<span i18n>Send Request</span>
						<g-icon [icon]="icons.faSpinner" size="2x" pulse />
					</button>
				</div>
			</form>
		</section>
	</div>
	<div class="container product-form-quote-container is-success" *ngIf="isSuccess">
		<h2 i18n>Thank you!</h2> <h3 i18n>Your message has been sent</h3>
		<div class="button-container" fxLayout="row" fxLayoutAlign="center">
			<button type="submit" class="btn btn-primary" i18n (click)="closeDialog()">Close</button>
		</div>
	</div>
</div>
